document.addEventListener('DOMContentLoaded', function() {
  class WishDrawer extends HTMLElement {
    constructor() {
      super();
      // Gestire la chiusura con il tasto Escape
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      // Gestire la chiusura con il click sull'overlay
      this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Inizializzare gli event listener sull'icona di ricerca
      this.initWishIconListeners();
    }

    initWishIconListeners() {
      // Trovare tutte le icone di ricerca e assegnare l'event listener
      const wishIcons = document.querySelectorAll('[id*="wishIconHeader"]');
      wishIcons.forEach((icon) => {
        icon.addEventListener('click', this.open.bind(this));
      });
    }

    open() {
      const wishDrawer = document.getElementById('WishDrawer');
      // Aggiungere le classi animate e active
      setTimeout(() => { wishDrawer.classList.add('animate', 'active'); });

      wishDrawer.addEventListener('transitionend', () => {
        const focusElement = wishDrawer.querySelector('.drawer__inner') || wishDrawer.querySelector('.drawer__close');
        trapFocus(wishDrawer, focusElement);
      }, { once: true });
 __this._wishlistPageWidgetData();
      // Prevenire lo scrolling del body
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
   /*   document.body.classList.add('overflow-hidden'); */
    }

    close() {
      const wishDrawer = document.getElementById('WishDrawer');
      wishDrawer.classList.remove('active');
      removeTrapFocus(this.activeElement);
   /*   document.body.classList.remove('overflow-hidden'); */
      document.body.style.paddingRight = '';
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }

  customElements.define('wishlist-drawer', WishDrawer);
});

